export default __webpack_public_path__ + "static/media/text-bg-2.f972edd7.png";